<template lang="html">
  <div v-if="content != null">
    <div class="d-flex flex-row align-items-center">
      <div class="row g-0 align-self-center align-items-center justify-content-center"
           id="contactTitle">
        <div class="cta-3 text-primary">Classé</div>
      </div>

      <button type="button"
              @click="delete_state()"
              class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-1 ms-auto">
        <i class="bi-trash"></i>
      </button>
    </div>
    <div class="text-alternate">{{ human_created_on }}</div>

    <span v-if="context.data.found_response">
            <i class="fa fa-check-circle has-text-success"></i>
            <span>&nbsp;</span>
            <span>Réponse vue {{ context.data.found_response.found_on|from_now }}</span>
            <a :href="get_scapped_answerlink(context.data.found_response.scarppedanswer_uid)"
               target="blank">&nbsp;Voir
            </a>
        </span>
    <br/><br/>
    <img :src="success_img_path"/>
  </div>
</template>

<script>
import tools from "@/tools.js";
import settings from "@/settings.coffee";

export default {
  name: "StateClassified",
  props: {
    context: {
      type: Object,
      required: true
    },
    review: {
      type: Object,
      required: true
    },
    human_created_on: String
  },
  data() {
    return {
      content: { uid: "0" },
      success_img_path: require("@/assets/success_" + String(this.context.uid[0]) + ".gif")
    };
  },
  methods: {
    get_scapped_answerlink(scarppedanswer_uid) {
      return settings.backendUrl +
        "/admin/review/scarppedanswer/" +
        scarppedanswer_uid + "/";
    },
    getTextFromReview(review, fr) {
      let ret = "";
      for (let r of review.state_set) {
        if (r.class_name === "AnswerAccepted") {
          if (fr) {
            ret = r.data.answer.text_fr;
          } else {
            ret = r.data.answer.text_native;
          }
        }
      }
      return ret;
    },
    random_number() {
      return String(Math.floor(Math.random() * 10));
    },
    copy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      this.$store.dispatch("notify", {
        level: "success",
        text: "Copié!",
        seconds: 2
      });
    },
    delete_state() {
      this.$emit("state:delete_state");
    }
  },
  created() {
    this.content = tools.deep_copy(this.context);
  }
};
</script>

<style lang="scss" scoped>
</style>
